import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
//import logo from './lemLuxRealty.png';


// import { createPageUrl } from '@/utils';
// import { base44 } from '@/api/base44Client';
import Icon from './components/ui/Icon';

const navItems = [
  { name: 'Dashboard', path: '/', icon: 'layoutDashboard' },
  { name: 'Listings', path: '/listings', icon: 'home' },
  { name: 'Agents', path: '/agents', icon: 'users' },
  { name: 'Transactions', path: '/transactions', icon: 'fileText' }
];


export default function Layout({ children, currentPageName }) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [user, setUser] = useState(null);

  // Simulate a logged-in user
useEffect(() => {
  // Placeholder user for now
  const placeholderUser = {
    full_name: 'John Doe',
    email: 'john.doe@example.com'
  };
  setUser(placeholderUser);
}, []);

// Simple logout handler
const handleLogout = () => {
  setUser(null); // just clear the user
  alert('Logged out'); // optional feedback
};


  const sidebarStyles = {
    position: 'fixed',
    top: 0,
    left: 0,
    bottom: 0,
    width: '16rem',
    background: 'var(--slate-900)',
    display: 'flex',
    flexDirection: 'column',
    zIndex: 100,
    boxShadow: '4px 0 8px rgba(0, 0, 0, 0.5)'
  };

  const logoStyles = {
    display: 'flex',
    flexDirection: 'column', 
    alignItems: 'flex-start',
    padding: '1.5rem',
    borderBottom: '1px solid var(--slate-800)'
  };

  return (
    <div style={{ minHeight: '100vh', background: 'var(--slate-50)' }}>
      {/* Desktop Sidebar */}
      <aside style={{ ...sidebarStyles, display: 'none' }} className="desktop-sidebar">
        <div style={logoStyles}>
          <div style={{ textAlign: 'center' }}>
      {/* <img src={logo} alt="LemLux Realty" style={{ width: '120px', height: 'auto' }} /> */}
    </div>
     <div>
            <h1 style={{ fontSize: '1rem', fontWeight: 700, color: 'white' }}>Lem Lux Realty</h1>
          </div>
<div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
  <div
    style={{
      background: 'var(--amber-500)',
      borderRadius: '0.5rem',
      padding: '0.25rem',
      display: 'flex'
    }}
  >
    <Icon name="building" size={20} style={{ color: 'var(--slate-900)' }} />
  </div>

  <p style={{ fontSize: '0.75rem', fontWeight: 700, color: 'var(--slate-400)', margin: 0 }}>
    Broker Portal
  </p>
</div>

          
         
        </div>

        <nav style={{ flex: 1, padding: '1.5rem 1rem' }}>
          {navItems.map(item => {
            const isActive = currentPageName === item.page;
            return (
              <Link
                key={item.name}
                to={item.path}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.75rem',
                  padding: '0.75rem 1rem',
                  borderRadius: '0.75rem',
                  marginBottom: '0.25rem',
                  textDecoration: 'none',
                  transition: 'all 0.2s',
                  background: isActive ? 'var(--amber-500)' : 'transparent',
                  color: isActive ? 'var(--slate-900)' : 'var(--slate-400)'
                }}
              >
                <Icon name={item.icon} size={20} />
                <span style={{ fontWeight: 500 }}>{item.name}</span>
              </Link>
            );
          })}
        </nav>

        {user && (
          <div style={{ padding: '1rem', borderTop: '1px solid var(--slate-800)' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', padding: '0.75rem' }}>
              <div style={{
                width: '2.5rem',
                height: '2.5rem',
                borderRadius: '50%',
                background: 'var(--slate-700)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: 'white',
                fontWeight: 600
              }}>
                {user.full_name?.[0] || user.email?.[0]?.toUpperCase()}
              </div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <p style={{ fontSize: '0.875rem', fontWeight: 500, color: 'white', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                  {user.full_name || 'User'}
                </p>
                <p style={{ fontSize: '0.75rem', color: 'var(--slate-400)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                  {user.email}
                </p>
              </div>
              <button onClick={handleLogout} style={{ padding: '0.5rem', background: 'none', border: 'none', cursor: 'pointer', color: 'var(--slate-400)' }}>
                <Icon name="logOut" size={16} />
              </button>
            </div>
          </div>
        )}
      </aside>

      {/* Mobile Header */}
      <div className="mobile-header" style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        background: 'var(--slate-900)',
        zIndex: 100,
        display: 'none'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '1rem' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
            <div style={{ padding: '0.5rem', background: 'var(--amber-500)', borderRadius: '0.5rem' }}>
              <Icon name="building" size={20} style={{ color: 'var(--slate-900)' }} />
            </div>
            <span style={{ fontSize: '1.125rem', fontWeight: 700, color: 'white' }}>RealtyPro</span>
          </div>
          <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} style={{ padding: '0.5rem', background: 'none', border: 'none', cursor: 'pointer', color: 'white' }}>
            <Icon name={mobileMenuOpen ? 'x' : 'menu'} size={24} />
          </button>
        </div>

        {mobileMenuOpen && (
          <div style={{ padding: '0 1rem 1rem' }}>
            {navItems.map(item => {
              const isActive = currentPageName === item.page;
              return (
                <Link
                  key={item.name}
                  to={item.path}
                  onClick={() => setMobileMenuOpen(false)}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.75rem',
                    padding: '0.75rem 1rem',
                    borderRadius: '0.75rem',
                    marginBottom: '0.25rem',
                    textDecoration: 'none',
                    background: isActive ? 'var(--amber-500)' : 'transparent',
                    color: isActive ? 'var(--slate-900)' : 'var(--slate-400)'
                  }}
                >
                  <Icon name={item.icon} size={20} />
                  <span style={{ fontWeight: 500 }}>{item.name}</span>
                </Link>
              );
            })}
            {user && (
              <button
                onClick={handleLogout}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.75rem',
                  padding: '0.75rem 1rem',
                  width: '100%',
                  borderRadius: '0.75rem',
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  color: 'var(--slate-400)'
                }}
              >
                <Icon name="logOut" size={20} />
                <span>Logout</span>
              </button>
            )}
          </div>
        )}
      </div>

      {/* Main Content */}
      <main className="main-content">
        {children}
      </main>

      <style>{`
        @media (min-width: 1024px) {
          .desktop-sidebar { display: flex !important; }
          .mobile-header { display: none !important; }
          .main-content { padding-left: 16rem; }
        }
        @media (max-width: 1023px) {
          .desktop-sidebar { display: none !important; }
          .mobile-header { display: block !important; }
          .main-content { padding-top: 4rem; }
        }
      `}</style>
    </div>
  );
}